<c-container fluid>
    <c-row class="justify-content-center mt-5">
        <c-col xs="12" md="8" lg="6">
            <c-card>
                <c-card-body class="text-center p-5">
                    <div class="mb-4" style="font-size: 3rem;">✅</div>
                    <h3>{{ 'kyc_confirmed_title' | translate }}</h3>
                    <p class="mt-3" style="color: rgba(255,255,255,0.7)">
                        {{ 'kyc_confirmed_message' | translate }}
                    </p>
                    <div class="mt-4">
                        <a cButton color="primary" [routerLink]="['/', lang(), 'kyc', 'sumsub']">
                            {{ 'kyc_sumsub_alert_link' | translate }}
                        </a>
                    </div>
                </c-card-body>
            </c-card>
        </c-col>
    </c-row>
</c-container>